import { CookieGroup } from '@core/domain/models/user-consent.models';
import { userConsentPoliciesValues } from '@core/services/user-consent/user-consent.service';

interface RestrictedParamsConfig {
    requiredCookie: string;
    marketsNotAllowed: string[];
}

/**
    StrictlyNecessary = "C0001"
    Analytics = "C0002"
    FeaturesOrCustomization = "C0003"
    Advertising = "C0004"
    SocialMedia = "C0005"
*/
export const restrictedParamsConfig: Record<string, RestrictedParamsConfig> = {
    clientId: { // device
        requiredCookie: 'C0002',
        marketsNotAllowed: ['CN'],
    },
    gclid: { // utm
        requiredCookie: 'C0002',
        marketsNotAllowed: [],
    },
    kind: { // identity
        requiredCookie: 'C0002',
        marketsNotAllowed: ['CN'],
    },
    token: { // identity
        requiredCookie: 'C0002',
        marketsNotAllowed: ['CN'],
    },
    userId: { // identity
        requiredCookie: 'C0002',
        marketsNotAllowed: ['CN'],
    },
};

export const filterRestrictedParams = (
    params: string[],
    cookieGroupMap: Record<userConsentPoliciesValues, CookieGroup>,
    currentStore: string
) => {
    return params.filter((param) => {
        const paramConfig = restrictedParamsConfig[param];
        if (!paramConfig) return true;
        return !paramConfig.marketsNotAllowed.includes(currentStore)
            && (!cookieGroupMap[paramConfig.requiredCookie] || cookieGroupMap[paramConfig.requiredCookie].allowed);
    });
};
